/**
 * The class that masks an element in FullStory session recordings (`lib/fullstory.ts`). `wr-mask` is
 * wix-recorder's mask class and `fs-mask` FullStory's own; either one masks in org 11CC00.
 *
 * Recording masks credentials only: passwords and one-time verification codes. `type="password"` is masked
 * by FullStory on its own, so this is for a credential field whose value is visible — a secure field with
 * its eye flipped renders as `type="text"`, and the OTP boxes (`OtpInput`) are plain text inputs.
 */
export const RECORDER_MASK_CLASS = 'wr-mask fs-mask';

export const RECORDER_EXCLUDE_CLASS = 'fs-exclude';
